import { Element, PlanetFilterInput } from '@apeiron/planet'
import { styled } from '@mui/material'
import BlurForm from '@src/components/share/filter/BlurForm'
import {
  FilterSection,
  FilterSectionContent,
  FilterSectionHeader,
  FilterSectionTitle
} from '@src/components/share/filter/FilterSection'
import RangeSlider from '@src/components/share/filter/RangeSlider'
import ResetFilter from '@src/components/share/filter/ResetFilter'
import { useElementContext } from '@src/contexts/planet/ElementContext'
import * as R from 'ramda'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const Content = styled(FilterSectionContent)`
  &.MuiAccordionDetails-root {
    padding-left: 24px;
    padding-right: 10px;
    padding-top: 8px;
    padding-bottom: 14px;
    overflow: hidden;
  }
`

const Form = styled(BlurForm)`
  > * + * {
    margin-top: 16px;
  }
`

const PlanetElementFilter: FC<Props> = (props: Props) => {
  const { className, filterOptions, onFilterOptionsChange } = props

  const { elements } = useElementContext()

  const { t } = useTranslation()

  const numFilters =
    (filterOptions.fireMin != null || filterOptions.fireMax != null ? 1 : 0) +
    (filterOptions.waterMin != null || filterOptions.waterMax != null ? 1 : 0) +
    (filterOptions.airMin != null || filterOptions.airMax != null ? 1 : 0) +
    (filterOptions.earthMin != null || filterOptions.earthMax != null ? 1 : 0)

  const onReset = useCallback(() => {
    onFilterOptionsChange({
      ...filterOptions,
      fireMin: undefined,
      fireMax: undefined,
      waterMin: undefined,
      waterMax: undefined,
      airMin: undefined,
      airMax: undefined,
      earthMin: undefined,
      earthMax: undefined
    })
  }, [filterOptions, onFilterOptionsChange])

  return (
    <FilterSection className={className} defaultExpanded>
      <FilterSectionHeader>
        <FilterSectionTitle>
          {t('filter.sections.pureness.title')}
        </FilterSectionTitle>
        <ResetFilter filterCount={numFilters} onReset={onReset} />
      </FilterSectionHeader>
      <Content>
        <Form>
          {R.map((element: Element) => {
            return (
              <RangeSlider
                filterOptions={filterOptions}
                key={element.value}
                labelIconURL={element.image}
                labelText={element.name}
                max={element.max}
                maxValueKey={`${element.value}Max`}
                min={element.min}
                minValueKey={`${element.value}Min`}
                onFilterOptionsChange={onFilterOptionsChange}
              />
            )
          }, elements)}
        </Form>
      </Content>
    </FilterSection>
  )
}

export type Props = {
  className?: string
  filterOptions: PlanetFilterInput
  onFilterOptionsChange: (input: PlanetFilterInput) => void
}

export default PlanetElementFilter
